import React from "react";
import {
  MuiThemeProvider,
  createMuiTheme,
  CssBaseline,
} from "@material-ui/core";

const configs = window.AppInfo;

const ThemeProvider = ({ children }) => {
  let theme = createMuiTheme({
    overrides: {
      MuiAppBar: {
        colorDefault: { backgroundColor: "#fafafa" },
      },
      MuiCardActionArea: {
        root: { color: configs?.primaryColor || "#2196f3" },
        focusHighlight: { color: configs?.primaryColor || "#2196f3" },
      },
      MuiButtonBase: {
        root: {
          focusVisible: { color: configs?.primaryColor || "#2196f3" },
        },
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 480,
        md: 680,
        lg: 960,
        xl: 1360,
      },
    },
    palette: {
      primary: {
        main: configs?.primaryColor || "#2196f3",
      },
      secondary: {
        main: configs?.secondaryColor || "#fffff",
      },
      background: {
        default: configs?.backgroundColor || "#fffff",
      },
    },
  });
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeProvider;
